module.exports = __webpack_public_path__ + "static/media/logoWhite.c5affd04.svg";